import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Pipeline, SearchProvider } from "@sajari/react-search-ui";

// Get the pipeline values for the context
const rootContainer = document.querySelector("#searchio-searchbox");
const account = rootContainer.dataset.account;
const collection = rootContainer.dataset.collection;
const resultsPage = rootContainer.dataset.resultsPage;

// Setup the search.io pipeline
const pipeline = new Pipeline(
  {
    account,
    collection,
  },
  "website"
);

const root = ReactDOM.createRoot(rootContainer);
root.render(
  <SearchProvider search={{ pipeline }}>
    <App resultsPage={resultsPage}/>
  </SearchProvider>
);
